import React from 'react';

import { basicReducer as reducer } from '../../../utils/reducers';

/**A Hook for updating the Record State. Currently only leveraged by ChangeApplicationStatus and the MUI DatePicker fields.
 *
 * @returns
 */
const useRecord = () => {
    let [recordState, dispatch] = React.useReducer(reducer, {
        dateErrors: [],
        initialized: false,
        shouldShowErrors: false,
        isChangeStatusOpen: false,
    });

    const handleDateChange = (section, key, newVal) => {
        var currentErrors = new Set(recordState?.dateErrors) || new Set();
        if (recordState?.[section]?.[key]?.answerText === '' && newVal !== null) {
            //Error cleared
            currentErrors.forEach((err) => {
                if (err.id === `${section}.${key}`) currentErrors.delete(err);
            });
        }
        dispatch({
            type: 'update',
            newState: {
                [section]: {
                    ...recordState[section],
                    [key]: {
                        ...recordState[section][key],
                        answerText: newVal?.toISOString?.() || '',
                    },
                },
                dateErrors: Array.from(currentErrors),
            },
        });
    };

    const handleDateError = (section, key, err, newVal) => {
        var id = `${section}.${key}`;
        if (recordState?.initialized) {
            let currentErrors = new Set(recordState?.dateErrors) || new Set();
            if (recordState[section][key]?.minResponseRequired >= 1 && (newVal?.toISOString() === null || newVal === null)) {
                //Required & Blank
                //Blanking the value with the Clear icon will produce a Moment object where toISOString will evalute to null
                //Blanking the value manually, i.e. backspacing in all the inputs, will produce a null value overall
                currentErrors.add({
                    id,
                    message: '(Required)',
                });
            } else if (err === 'minDate' || err === 'maxDate') {
                //minDate or maxDate
                currentErrors.add({
                    id,
                    message: '(Invalid Date)',
                });
            } else if (err === null) {
                //Error cleared
                currentErrors.forEach((err) => {
                    if (err.id === id) currentErrors.delete(err);
                });
            }

            dispatch({
                type: 'update',
                newState: {
                    [section]: {
                        ...recordState[section],
                        [key]: {
                            ...recordState[section][key],
                            answerText: newVal?.toISOString?.() || '',
                        },
                    },
                    dateErrors: Array.from(currentErrors),
                },
            });
        }
    };

    const initializeRecord = (initState) => {
        dispatch({
            type: 'update',
            newState: {
                ...initState,
                initialized: true,
            },
        });
    };

    const showErrors = () => {
        dispatch({
            type: 'update',
            newState: {
                shouldShowErrors: true,
            },
        });
    };

    const handleChangeStatus = (boolOpen) => {
        dispatch({
            type: 'update',
            newState: {
                isChangeStatusOpen: boolOpen,
            },
        });
    };

    return {
        recordState,
        initializeRecord,
        handleDateChange,
        handleDateError,
        showErrors,
        handleChangeStatus,
    };
};

export default useRecord;

